module.exports = __webpack_public_path__ + "static/media/new-post-created.500bc117.svg";